module.exports = __webpack_public_path__ + "img/metrics-empty.f2171d5.svg";